import { useState } from 'react';
import type { SectionDef } from '../data/sections';
import styles from './FormSection.module.css';

interface FormSectionProps {
  section: SectionDef;
  value: string;
  onChange: (value: string) => void;
}

export function FormSection({ section, value, onChange }: FormSectionProps) {
  const [showHelp, setShowHelp] = useState(false);
  const fieldId = `s-${section.key}`;

  return (
    <fieldset className={styles.field}>
      <div className={styles.head}>
        <label htmlFor={fieldId} className={styles.legend}>
          {section.formLegend}
        </label>
        <button
          type="button"
          className={styles.helpToggle}
          onClick={() => setShowHelp((v) => !v)}
          aria-expanded={showHelp}
        >
          {showHelp ? '— hide prompts' : '? show prompts'}
        </button>
      </div>

      {showHelp && (
        <div className={styles.help}>
          <p className={styles.helpTitle}>think about</p>
          <ul className={styles.helpList}>
            {section.examples.map((ex, i) => (
              <li key={i}>{ex}</li>
            ))}
          </ul>
          {section.starters.length > 0 && (
            <>
              <p className={styles.helpTitle}>starters</p>
              <div className={styles.starters}>
                {section.starters.map((s, i) => (
                  <button
                    key={i}
                    type="button"
                    className={styles.starterChip}
                    onClick={() => {
                      const next = value.trim() ? `${value.trim()}\n${s}` : s;
                      onChange(next);
                    }}
                  >
                    {s}
                  </button>
                ))}
              </div>
            </>
          )}
        </div>
      )}

      <textarea
        id={fieldId}
        className={styles.textarea}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="write here…"
        rows={4}
      />

      <p className={styles.charCount}>{value.length} characters</p>
    </fieldset>
  );
}
